export const ScreenSizeConfiguration = {
  mobileScreen: 800,
  tabScreen: 950,
  tabviewStart: 801,
  tabviewEnd: 1024,
  desktopView: 1025,
};

export const IntervalConfiguration = {
  intervalTiny: 100,
  intervalExtraSmall: 200,
  intervalSmallMid: 350,
  intervalSmaller: 400,
  intervalSmall: 600,
  intervalMid: 460,
  intervalSemiMid: 700,
  intervalMedium: 1000,
  intervalLarge: 1500,
  intervalExtraLarge: 2000,
  intervalExtraLarger: 3000,
  intervalTicker: 7000,
  intervalTestNotification: 10000,
  intervalPopup: 6000,

  intervalSpeedTicker: 50,
  intervalTimeout: 270,

  statementRefreshTime: 300,
  minuteInSecond: 60,
};

export const RejectReasonLength = {
  lengthOfReason: 200,
  lengthOfDecline: 150,
};

export const errorcode = {
  errorNotFound: 404,
  errorFailed: 500,
  errorUnAuthorized: 401,
  unprocessableContent: 422,
};

export const PaginationConfiguration = {
  paginationOptions: [50, 100],
  paginationSmall: 50,
  paginationBig: 100,
  paginationMid: 250,
  paginationExtraSmall: 102,
  currentPageText: "01",
  pageSize: 192,
};

export const GeoMapLeafletIcon = {
  /* customIcon */
  iconSize: [38, 38],
  iconAnchor: [19, 38],
  popupAnchor: [0, -38],
};

export const locationDefault = {
  officeLocation: [19.043690333072874, 72.8429991],
};

export const TimelineBarConfiguration = {
  extrasmallwidth: 0.25,
  smallwidth: 0.5,
  mediumwidth: 0.75,
  largewidth: 1,
};

export const nameConfiguration = {
  gchat: "Google chat",
  teams: "Microsoft teams",
  slack: "Slack",
  generic: "Custom webhook",
  "Google chat": "gchat",
  "Microsoft teams": "teams",
  Slack: "slack",
  "Custom webhook": "generic",
  webhook: "generic",
  Webhook: "generic",
  tds: "Tax",
  tds: "Tax",
  income_tax: "Tax",
  incometax: "Tax",
  pt: "Tax",
  gst: "Tax",
};

export const GlobalConfiguration = {
  scrollPixel: 80,
  scrollPixelUp: 30,
  gstLength: 15,
  entityCardMinHeight: "110px",
  BeneAccCardMinHeight: "160px",
  IntAccCardMinHeight: "110px",
  ReimAccCardMinHeight: "110px",
  BeneTxnCardMinHeight: "160px",
  OwnerCardMinHeight: "160px",
  FieldForceTxnCardMinHeight: "206px",
  inputValidationLength: 50,
  numericAccountLength: 18,
  alphanumericAccountLength: 32,
  selectionLength: 50,
  placeHolderAnimationLength: 80,
  fieldForceAccountountCardHoverHeight: 110,
  fieldForceAccountountListHoverHeight: 65,
  panLength: 10,
  ifscLength: 11,
  cinLength: 21,
  dinLength: 8,
  searchHeight: 10,
  accountminLength: 3,
  searchMaxOptionLength: 5,
  searchMinLength: 3,
  searchMaxLength: 50,
  accountnormalLength: 9,
  owneraccountnormalLength: 10,
  categoryminLength: 3,
  categorymaxLength: 20,
  categoryBenemaxLength: 50, // temp
  lengthCheckZero: 0, //MENTIONED FOR THE ADD CATEGORY FLOW
  lengthCheckOne: 1, //MENTIONED FOR THE ADD CATEGORY FLOW
  lengthCheckNegativeOne: -1,
  lengthCheckTwo: 2,
  lengthCheckThree: 3,
  lengthCheckFour: 4,
  lengthCheckFive: 5,
  lengthCheckSix: 6,
  lengthCheckSeven: 7,
  dashboardPrimaryCount: "00",
  inputMaxLength: 150,
  scannerSize: 150,
  filtered_search_min: "50px",
  filteredSearchHeight: 50,
  filter_search_height: "158px",
  navigate_back: -1,
  settleTypeValue: 200000,
  currentYear: 1975,
  innerWidthLargeSize: 3840,
  innerWidthMidSize: 2560,
  filterResults: 5,
  actionDelay: 3000,
  rtgs: 200000,
  otpCount: 60,
  otpLength: 6,
  delayTime: 1000,
  delayTimeMid: 4000,
  day_in_seconds: 86400,
  defaultAmount: 10000,
  autoCloseTime: 5000,
  rejectReasonMinLength: 10,

  // Card and List Hover Heights

  // Accounts
  notificationCardHeight: 164,

  // Accounts
  beneAccountCardHoverHeight: 90,
  beneAccountListHoverHeight: 40,
  internalAccountCardHoverHeight: 90,
  internalAccountListHoverHeight: 40,
  ownerAccountCardHoverHeightWithoutRefresh: 160,
  ownerAccountCardHoverHeightWithRefresh: 210,
  ownerAccountListHoverHeightWithoutRefresh: 130,
  ownerAccountListHoverHeightWithRefresh: 180,
  reimbursementAccountCardHoverHeight: 90,
  reimbursementAccountListHoverHeight: 40,
  userHoverHeight: 40,
  ownerStatementWindowHeightThreshold: 620,
  taxAccGridCardHeight: 130,
  taxAccListCardHeight: 88,
  taxAccApprCardHeight: 368,
  remitterAcountGridCardHeight: 140,
  remitterAccountListCardHeight: 70,
  beneAccGridCardHeight: 120,
  beneAccListCardHeight: 90,

  // Transactions
  beneTxnCardHoverHeight: 280,
  beneTxnListHoverHeight: 90,
  internalTxnCardHoverHeight: 180,
  internalTxnListHoverHeight: 90,
  beneScheduleTxnCardHoverHeight: 110,
  reminderCardHoverHeight: 110,
  internalScheduleTxnCardHoverHeight: 60,
  reimbursementTxnCardHoverHeight: 29,
  reimbursementTxnCardMinHeight: 210,
  reimbursementTxnListHoverHeight: 90,
  reimbursementRequestCardHoverHeightWithAmount: 110,
  reimbursementRequestCardHoverHeightWithoutAmount: 60,
  reimbursementRequestListHoverHeight: 60,
  privateTxnCardHoverHeightWithoutAmount: 160,
  privateTxnListHoverHeight: 63,
  channelViewallCardHoverHeight: 40,
  taxTxnGridCardHeight: 180,
  taxTxnListCardHeight: 89,
  taxTxnSingleApprCardHeight: 265,
  taxTxnMultiApprSelectCardHeight: 265,
  taxTxnMultiApprCardHeight: 329,
  bulkTxnCardHeight: 230,
  beneTxnGridCardHeight: 177,
  beneTxnListCardHeight: 89,
  beneSchTxnCardHeight: 230,
  beneTxnMultiApprselectCardHeight: 184,
  beneTxnMultiApprCardHeight: 326,
  beneTxnSingleApprCardHeight: 275,  
  beneScheduleTxnSingleApprCardHeight: 346,
  beneSchTxnMultiApprselectCardHeight: 236,
  beneSchTxnMultiApprCardHeight: 350,
  beneTxnReCreateDashCardHeight: 265,
  singleReqApprovalTxnCardHeight: 244,

  // MultiApproval
  beneTxnMultiApprovalCardHoverHeight: 40,
  internalTxnMultiApprovalCardHoverHeight: 40,
  reimbursementTxnMultiApprovalCardHoverHeight: 40,
  ownerAccountConnectedBankingLength: 50,
  maxAllowedAmount: 99_99_99_999.99,
};

export const CategoryFieldConfiguration = {
  fieldOptions: [
    { "Input field (alphanumeric)": "string" },
    { "Input field (numeric)": "numeric" },
    { "Single select dropdown": "list" },
    { "Multi select dropdown": "multi_select_list" },
    { "Day selector": "day" },
    { "Date selector": "date" },
    { "Month selector": "month" },
    { "Year selector": "year" },
    { "Month year selector": "month_year" },
    { "Date range selector": "date_range" },
    { "Year range selector": "from_year_to_year" },
    { Toggle: "toggle" },
    { "Upload file": "upload" },
    { "Set time": "time" },
    { Quantity: "quantity" },
    { "Enter URL": "hyperlink" },
  ],
};

export const SettingsStatisticsConfiguration = {
  //settings/statistics page settings
  targetGraphCardTopOffset: 20,

  //settings/statistics/components/IncomeOnIdleFunds page settings
  interestRate: 6.5,
  investmentPercent: 100,

  // Pie Chart Config
  pieChartOuterRadius: 100,
  pieChartInnerRadius: 50,
  pieChartOuterRadiusMobile: 120,
  pieChartInnerRadiusMobile: 60,
  pieChartHeight: 199,
  pieChartHeightMobile: 250,
  pieChartPaddingAngle: 2,
  pieChartStartAngle: 0,
  pieChartEndAngle: 360,

  // Line Graph Config
  outerStrokeRingRadius: 5.5,
  outerStrokeWidth: 1.5,
  innerSolidCircleRadius: 3.5,
  fillOpacityForLineGraph: 0.1,
  strokeWidthForLineGraph: 2,
  smallStrokeWidthForLineGraph: 1,
  radiusOfMarkForLineGraph: 6,
  zeroStrokeWidthForLineGraph: 0,
  graphPaddingLeft: 55,
  graphPaddingRight: 20,
  graphXAxisPaddingPercent: 0.04,
  graphMinWidthPerDataPoint: 30,
  graphRangeLabelEdgeHeight: 10,
  graphMonthLabelGapX: 16,
  graphYAxisTickCount: 4,
  graphRangeLabelOffsetY: 35,
  graphRangeLabelSingleDateHalfWidth: 18,
};

export const TimelineConfiguration = {
  timeDuration: 100,
  totalSeconds: 1000,
  oneHour: 60,
  oneDay: 24,
  barwidthBase: 0.5,
  barWidthSmall: 1,
  barWidthMedium: 2,
  barWidthLarge: 3,
  actionBarWidth: 1.5,
};

export const PaymentMethodAnimationConfiguration = {
  slideDuration: 800,
};

export const TimePickerConfiguration = {
  hour: 12,
  minute: 60,
  meridiem: ["am", "pm"],
};

export const TopNavMenu = {
  menuItems: 2,
};

export const maxFileSize = 12 * 1024 * 1024;

export const dropdownHierarchy = {
  "approval status": 1,
  "distribution status": 2,
  "account status": 3,

  "file status": 4,

  "channel/category status": 5,
  "channel status": 5,
  "category status": 5,
  status: 5,
  "channel linkage": 5,

  "owner account": 6,

  "date range": 7,

  "schedule start date": 8,
  "start date": 8,

  "schedule end date": 9,
  "end date": 9,

  "amount range": 10,
  "payment method": 11,

  "show/hide confidential transactions": 12,
  "show/hide confidential schedules": 12,
  "show/hide confidential": 12,

  "show/hide favourite": 13,
  "account type": 14,
  "account state": 15,
  "account origin": 15,

  "notification type": 16,
  type: 16,
  "connected banking": 17,
  "occurrence rate": 18,

  frequency: 19,
  "created via": 20,
  "transaction type": 21,

  "statement source": 22,
  "match status": 23,

  "remitter account": 24,
};

export const BankingHoursConfiguration = {
  startHour: 9,
  startMinute: 0,
  endHour: 18,
  endMinute: 15,
  outsideHoursLabel: "6:15 PM to 9:00 AM",
};
